import { ReactComponent as AddIcon } from '../../components/icons/add-icon.svg';
import { ReactComponent as Teacher } from '../../components/icons/teacher.svg';
import SortArrows from '../../components/icons/sort-arrows.jsx';
import store from '../../store/store.js'; // Import magazynu Redux
import { clearCheckedItems, toggleNeedRefresh, setKeyword, setSearchValue} from '../../store/faqTabSlice.js';
import ApiService from '../../components/api_services/apiService';

// Akcje dla tabeli użytkowników
export const actions = {  
  // addSport: () => {
  //   console.log('Dodaj sport kliknięte');
  //   handleOpenModal;
  //   // Logika otwierania modala lub przekierowania do formularza dodawania sportu
  // },
 deleteSelected: async (dispatch) => {
    // Pobierz `checkedItems` ze stanu Redux    
    const state = store.getState();
    const selectedIds = state.faq.checkedItems;

    if (selectedIds.length === 0) {
      alert('Nie wybrano żadnych elementów do usunięcia.');
      return;
    }

    try {
      const response = await ApiService.deleteNotifByIdList(selectedIds);

      // Obsługa odpowiedzi serwera
      if (response.status === 200) {
        alert('Wszystkie notyfikacje zostały usunięte!');
      } else if (response.status === 206) {
        alert('Niektóre notyfikacje nie mogły zostać usunięte!');
      } else if (response.status === 204) {
        alert('Nie znaleziono notyfikacji do usunięcia!');
      }

      // Wyzerowanie zaznaczonych elementów
      dispatch(clearCheckedItems());
      dispatch(toggleNeedRefresh());

    } catch (error) {      
      console.error('Błąd podczas usuwania notyfikacji:', error);
      alert('Wystąpił błąd podczas usuwania notyfikacji.');
    }
  },
  // searchUsers: (query) => {
  //   console.log('Wyszukaj użytkowników:', query);
  //   // Logika wyszukiwania użytkowników
  // },
  // changeTab: (tabName, dispatch, setActiveUsersTab) => {
  //   console.log('Zmieniono zakładkę na:', tabName);
  //   dispatch(setActiveUsersTab(tabName));
  // },
};

// Konfiguracja nagłówków tabeli

export const getHeaders = (dispatch, rowsSports, checkedItems) => [
  <input
    type="checkbox"
    checked={rowsSports.every((row) => checkedItems.includes(row[1]))}
    onChange={(e) => {
      if (e.target.checked) {
        // Dodaj wszystkie widoczne elementy do checkedItems
        rowsSports.forEach((row) => {
          if (!checkedItems.includes(row[1])) {
            dispatch({ type: 'faq/toggleCheckedItem', payload: row[1] });
          }
        });
      } else {
        // Usuń wszystkie widoczne elementy z checkedItems
        rowsSports.forEach((row) => {
          if (checkedItems.includes(row[1])) {
            dispatch({ type: 'faq/toggleCheckedItem', payload: row[1] });
          }
        });
      }
    }}
    />,
  <div className="table-columns-headers">
    <div>ID</div>
  </div>,
  <div className="table-columns-headers">
    <div>Pytanie PL</div>
  </div>,
  <div className="table-columns-headers">
    <div>Odpowiedź PL</div>
  </div>,
    <div className="table-columns-headers">
    <div>Pytanie ENG</div>
  </div>,

  <div className="table-columns-headers">
    <div>Odpowiedź ENG</div>
  </div>,
  <div className="table-columns-headers">
  <div>Akcje</div>
</div>,
];

export const empty = [];

// Szerokości kolumn
export const headerWidths = ['42px', '65px', '1fr', '1fr', '1fr','1fr', '100px'];

// Konfiguracja zakładek
export const tabsConfig = (activeUsersTab, dispatch, setActiveUsersTab) => [
  {
    icon: Teacher,
    name: 'FAQ',
    hoverClass: 'hover-effect',
    activeClass: activeUsersTab === 'Dyscypliny' ? 'is-active' : '',
    onClick: () => {},
    toggleActive: true,
  },
];

// Konfiguracja przycisków
export const buttonsConfig = ( toggleAddModal ) => [  
  {
    icon: AddIcon,
    name: 'Dodaj',
    baseClass: 'custom-button-black',
    hoverClass: 'hover-effect',
    activeClass: '',
    onClick: () => {
      toggleAddModal();
    },
    toggleActive: false,
  },
];